import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { Home, History, Bus, Bell, User } from "lucide-react";
import BottomNav from "@/components/BottomNav";
import { api } from "@/lib/api";

export default function EmployeeShell() {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/notifications/unread-count");
        setUnread(data?.count || 0);
      } catch (e) {
        // ignore
      }
    };
    load();
    const t = setInterval(load, 20000); // WS gives instant; polling is safety net
    return () => clearInterval(t);
  }, []);

  const items = [
    { to: "/app", icon: Home, label: "Home", testId: "tab-home", end: true },
    { to: "/app/rides", icon: History, label: "Rides", testId: "tab-rides" },
    { to: "/app/bus", icon: Bus, label: "Bus", testId: "tab-bus" },
    { to: "/app/notifications", icon: Bell, label: "Alerts", testId: "tab-notifications", badge: unread },
    { to: "/app/profile", icon: User, label: "Profile", testId: "tab-profile" },
  ];
  return (
    <div className="mobile-shell pb-24" data-testid="employee-shell">
      <Outlet />
      <BottomNav items={items} />
    </div>
  );
}
